/* eslint-disable */
import React from "react";
import "./AssociateCompanies.css";

function AssociateCompanies() {
    const companies = [
        {
            id: 1,
            name: "ROYAL NATURAL DRIED FRUITS",
            image: "images/slides/royal.png",
            description:
                "Since 1987, Royal Dry Fruits has pioneered premium-quality dry fruits, spices, and confectionaries. With 35 years of excellence, 200+ products, and 1,000+ happy customers, we serve both wholesalers and retailers across India. Our nutrient-rich range includes mixes, dates, seeds, nuts, and masalas. Backed by 24/7 customer support, we deliver health, taste, and satisfaction.",
        },
        {
            id: 2,
            name: "N&M Impex Pvt Ltd.",
            image: "images/slides/NM.png",
            description: " is a leading exporter of premium dried fruits and nuts from Pakistan & Afghanistan to North America, Europe, and the Middle East. With advanced technology, we preserve nutritional integrity, ensuring quality, taste, and wellness in every bite.",
        },
        {
            id: 3,
            name: "B&B Ltd",
            image: "images/slides/bbb.png",
            description: "A company dealing in the import and export of all types of dry fruits. Their expertise and commitment to quality align with our values, making them a key partner in fulfilling large-scale international orders.",
        },
    ];

    return (
        <section className="associate-section">
            <h2 className="associate-title">Our Associate Companies</h2>

            <div className="associate-grid">
                {companies.map((company) => (
                    <div className="flip-card" key={company.id}>
                        <div className="flip-card-inner">
                            {/* Front */}
                            <div className="flip-card-front">
                                <img src={company.image} alt={company.name} />
                            </div>

                            {/* Back */}
                            <div className="flip-card-back">
                                <h3>{company.name}</h3>
                                <p>{company.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default AssociateCompanies;
